<template>
  <div class="width-hundred height-hundred">
    <!-- 导航栏 -->
    <!-- <navigate></navigate> -->
    <nav class="navbar resize navbar-expand-sm  color-white navigate col align-items-center" :style="transparent?'background:transparent':'backgroundColor:rgba(0,0,0,0.5)'">
      <!-- 确保无论是宽屏还是窄屏，navbar-brand都显示 -->
      <!-- <a href="##" class="navbar-brand">导航栏</a> -->
      <img class="logo navbar-brand" src="../assets/images/zksino_logo.png" :style="{left:clientWidth/2-50+'px'}">
      <div class="container-fluid row">
        　<!-- .navbar-toggle样式用于toggle收缩的内容，即nav-collapse collapse样式所在元素 -->   
        <button v-if='!transparent' class="navbar-toggler icon-50" type="button" data-toggle="collapse" data-target="#navigate-menu">
          <img class="menu-img" src="../assets/images/navigate_menu.png">
        </button>
        <!-- 屏幕宽度小于768px时，div.navbar-responsive-collapse容器里的内容都会隐藏，显示icon-bar图标，当点击icon-bar图标时，再展开。屏幕大于768px时，默认显示。 -->
        <div class="collapse navbar-collapse" id="navigate-menu" :style="{backgorund:'#ECECEC'}">
          <div class="col-md-3 text-center height-50 navigate-menu-item"><span class="pointer" @click="navigateTo('/solution')">解决方案</span></div>
          <div class="col-md-3 text-center height-50 navigate-menu-item"><span class="pointer" @click="navigateTo('/product')" >我们的案例</span></div>
          <div class="col-md-3 text-center height-50 navigate-menu-item"><span class="pointer" @click="navigateTo('/service')" >服务</span></div>
          <div class="col-md-3 text-center height-50 navigate-menu-item"><span class="pointer" @click="navigateTo('/ourCase')" >联系我们</span></div>
        </div>
      </div>
    </nav>
    <!-- 导航栏 -->

    <div>
      <!-- 轮播图 -->
      <div class="swiper-container" v-bind:style="{height: clientHeight+'px'}">
        <div class="swiper-wrapper height-hundred">
          <div v-for='(item,index) in banners' :key="index" class="swiper-slide height-hundred">
            <img class="img cover" v-bind:style="{width: clientWidth+'px',minWidth: clientWidth+'px',height: clientHeight+'px',minHeight: clientHeight+'px'}" v-bind:src="item"/>
          </div>
        </div>
        <!-- 分页器 小圆点 -->
        <div class="swiper-pagination"></div>
        <div v-if="show" class="pre-next">
          <img class="pre-img icon-40" src="../assets/images/toLeft.png">
          <img class="next-img icon-40" src="../assets/images/toRight.png">
        </div>
      </div>
      <!-- 轮播图 -->

      <!-- 解决方案 -->
      <div id="solution" class="col">
        <div class="section-title">
          <div class="col">
            <div class="section-line"></div>
            <h2 class="section-h3 color-gray">解决方案</h2>
          </div>
        </div>
        <div class="row align-items-center">
          <ul class="col-md-6 row m-top-50">
            <li v-for="(item,idx) in solutions" :key="item.id" :data-id="idx" class="solution-item col align-items-center"  @mouseover="solutionItemMoveOver(idx)" @mouseleave="solutionItemMoveOut(idx)">
              <img class="solution-item-img icon-80" :src="item.img"/>
              <div class="solution-item-title color-orangered col align-items-center justify-content-center">
                <h6 v-show='item.show'>{{item.title}}</h6>
              </div>
            </li>
          </ul>
          <div class="col-md-6 soution-right col align-items-center justify-content-center" :style="{height:clientHeight/2+'px'}">
            <div v-if="show" class="background-size-cover col-md-10 height-hundred col overhide relative" @mouseover="solutionImgMoveOver" @mouseleave="solutionImgMoveOut" >
              <div class="solution-right background-size-cover icon-hundred relative z-index-20" :style="{top:-clientHeight*5/12+'px'}">
                <div class="service-text2 color-white icon-hundred">
                  <h3 class="m-bottom-20">{{solution.title}}</h3>
                  <h5 class="width-hundred nowrap text-ellipsis overhide">{{solution.title_en}}</h5>
                  <!-- <div class="toMore">进入</div> -->
                </div>
              </div>
              <div>
                  <img class="solution-right-img cover relative z-index-10" :src="solution.img"
                  :style="{top:-clientHeight*5/12+'px',width:clientWidth*5/12+'px',height:clientHeight*5/12+'px'}" />
              </div>
            </div>
            <div v-else class="background-size-cover col-md-10 height-hundred col overhide relative" @mouseover="solutionImgMoveOver" @mouseleave="solutionImgMoveOut" >
              <div class="solution-right background-size-cover icon-hundred " :style="{backgroundImage:'url('+solution.img+')'}" >
                <div class="service-text color-white width-eighty height-eighty">
                  <h3 class="m-bottom-20">{{solution.title}}</h3>
                  <h5 class="width-hundred nowrap text-ellipsis overhide">{{solution.title_en}}</h5>
                  <!-- <div class="toMore">进入</div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 产品 -->
      <div id="product" class="col">
        <div class="section-title">
          <div class="col">
            <div class="section-line"></div>
            <h2 class="section-h3 color-gray">产品</h2>
          </div>
        </div>
        <div class="col align-items-center overhide" :style="{height:clientHeight/3+'px',minHeight:clientHeight/3+'px'}">
          <div class="products width-ninety overhide" :style="{height:clientHeight/3+'px',minHeight:clientHeight/3+'px'}">
            <div v-if="productShow" class="swiper-wrapper height-hundred">
              <div v-for='(item,index) in products' :key="index" class="swiper-slide height-hundred width-Onethird" :style="{height:clientHeight/3+'px',minHeight:clientHeight/3+'px'}">
                <div class="height-hundred background-size-cover row" :style="{backgroundImage:'url('+item.img+')'}">
                  <div class="service-text color-white width-eighty height-eighty">
                    <h3 class="m-bottom-20">{{item.title}}</h3>
                    <h5 class="width-hundred nowrap text-ellipsis overhide">{{item.title_en}}</h5>
                    <!-- <div class="toMore">进入</div> -->
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="swiper-wrapper height-hundred">
              <div v-for='(item,index) in products' :key="index" class="swiper-slide height-hundred" :style="{width:clientWidth*9/10+'px',minWidth:clientWidth*9/10+'px'}">
                <div class="height-hundred background-size-cover row" :style="{backgroundImage:'url('+item.img+')'}">
                  <div class="service-text color-white width-eighty height-eighty">
                    <h3 class="m-bottom-20">{{item.title}}</h3>
                    <h5 class="width-hundred nowrap text-ellipsis overhide">{{item.title_en}}</h5>
                    <!-- <div class="toMore">进入</div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="product-pre-next">
            <img class="product-pre-img" src="../assets/images/leftArrow-black.png" :style="{width:clientWidth/20+'px',height:clientWidth/20+'px'}">
            <img class="product-next-img" src="../assets/images/rightArrow-black.png" :style="{width:clientWidth/20+'px',height:clientWidth/20+'px'}"/>
          </div>
        </div>
      </div>

      <!-- 服务 -->
      <div id="service" class="col">
        <div class="section-title">
          <div class="col">
            <div class="section-line"></div>
            <h2 class="section-h3 color-gray">服务</h2>
          </div>
        </div>
        <div class="row align-items-center" :style="{marginLeft:clientWidth/20+'px',marginRight:clientWidth/20+'px'}">

          <div class="service-bannerleft col-md-6 background-size-cover height-hundred" :style="{height:half+'px',backgroundImage:'url('+services[0].img+')',marginBottom:clientWidth/48+'px'}">
            <div class="service-text color-white width-eighty height-eighty">
              <h3 class="m-bottom-20">{{services[0].title}}</h3>
              <h5>{{services[0].title_en}}</h5>
              <!-- <div class="toMore">更多</div> -->
            </div>
          </div>

          <div class="service-right col-md-6 row " :stytle="{height:half+'px',}">
            <div class="col-md-6 row flex-row-reverse" :style="{height:half*23/48+'px',marginBottom:clientWidth/48+'px'}">
              <div class="col-md-11 height-hundred background-size-cover overhide" :style="{backgroundImage:'url('+services[1].img+')'}">
                <div class="service-text color-white width-eighty height-eighty">
                  <h3 class="m-bottom-20">{{services[1].title}}</h3>
                  <h5>{{services[1].title_en}}</h5>
                  <!-- <div class="toMore">更多</div> -->
                </div>
              </div>
            </div>
            <div class="col-md-6 row flex-row-reverse" :style="{height:half*23/48+'px',marginBottom:clientWidth/48+'px'}">
              <div class="col-md-11 height-hundred background-size-cover overhide" :style="{backgroundImage:'url('+services[2].img+')'}">
                <div class="service-text color-white width-eighty height-eighty">
                  <h3 class="m-bottom-20">{{services[2].title}}</h3>
                  <h5>{{services[2].title_en}}</h5>
                  <!-- <div class="toMore">更多</div> -->
                </div>
              </div>
            </div>
            <div class="col-md-6 row flex-row-reverse" :style="{height:half*23/48+'px',marginBottom:clientWidth/48+'px'}">
              <div class="col-md-11 height-hundred background-size-cover overhide" :style="{backgroundImage:'url('+services[3].img+')'}">
                <div class="service-text color-white width-eighty height-eighty">
                  <h3 class="m-bottom-20">{{services[3].title}}</h3>
                  <h5>{{services[3].title_en}}</h5>
                  <!-- <div class="toMore">更多</div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 我们的案例 -->
      <div id="ourCase" class="col">
        <div class="section-title">
          <div class="col">
            <div class="section-line"></div>
            <h2 class="section-h3 color-gray">我们的案例</h2>
          </div>
        </div>
        <div class="row align-items-center" :style="{marginLeft:clientWidth/20+'px',marginRight:clientWidth/20+'px'}">
          <div class="col-md-4 row" :style="{height:clientHeight/3+'px',marginBottom:clientWidth/36+'px'}">
            <div class="background-size-cover col-md-11 height-hundred" :style="{backgroundImage:'url('+ourCase[0].img+')'}">
              <div class="service-text color-white width-eighty height-eighty">
                <h3 class="m-bottom-20">{{ourCase[0].title}}</h3>
                <h5>{{ourCase[0].title_en}}</h5>
                <!-- <div class="toMore">更多</div> -->
              </div>
            </div>
          </div>
          <div class="col-md-8 row background-size-cover" :style="{height:clientHeight/3+'px',backgroundImage:'url('+ourCase[1].img+')',marginBottom:clientWidth/36+'px'}">
            <div class="service-text color-white width-eighty height-eighty">
              <h3 class="m-bottom-20">{{ourCase[1].title}}</h3>
              <h5>{{ourCase[1].title_en}}</h5>
              <!-- <div class="toMore">更多</div> -->
            </div>
          </div>
          <div class="col-md-8 row background-size-cover" :style="{height:clientHeight/3+'px',backgroundImage:'url('+ourCase[2].img+')',marginBottom:clientWidth/36+'px'}">
            <div class="service-text color-white width-eighty height-eighty">
              <h3 class="m-bottom-20">{{ourCase[2].title}}</h3>
              <h5>{{ourCase[2].title_en}}</h5>
              <!-- <div class="toMore">更多</div> -->
            </div>
          </div>
          <div class="col-md-4 row flex-row-reverse" :style="{height:clientHeight/3+'px',marginBottom:clientWidth/36+'px'}">
            <div class="background-size-cover col-md-11 height-hundred" :style="{backgroundImage:'url('+ourCase[3].img+')'}">
              <div class="service-text color-white width-eighty height-eighty">
                <h3 class="m-bottom-20">{{ourCase[3].title}}</h3>
                <h5>{{ourCase[3].title_en}}</h5>
                <!-- <div class="toMore">更多</div> -->
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <Foot></Foot>
  </div>
</template>

<script>
  import navigate from "../components/navigate.vue";
  import Swiper from 'swiper';
  import 'swiper/dist/css/swiper.css';
  import Foot from '../components/Foot.vue'

  export default {
    name: 'Index',
    components:{
      navigate,
      Foot
    },
    data () {
      return {
        clientHeight:null,
        clientWidth:null,
        half:null,//取clientHeight,clientWidth较大的一个的一半
        show:true,
        footerHeight:300,
        transparent:true,

        // 轮播-----------------------------
        banners:[
          require("../assets/images/timg.jpg"),
          require("../assets/images/timg1.jpg"),
          require("../assets/images/timg2.jpg"),
          require("../assets/images/timg3.jpg")
        ],
     
        // 轮播-----------------------------


        // 解决方案-------------------
        solutions:[
          {id:1,title:'采集',show:false,img:require("../assets/images/caiji.png")},
          {id:2,title:'传输',show:false,img:require("../assets/images/chuanshu.png")},
          {id:3,title:'储存',show:false,img:require("../assets/images/chucun.png")},
          {id:4,title:'处理',show:false,img:require("../assets/images/chuli.png")},
          {id:5,title:'显示',show:false,img:require("../assets/images/xianshi.png")},
          {id:6,title:'控制',show:false,img:require("../assets/images/kongzhi.png")},
        ],
        solutionsRight:[
          {
            title:'多终端拉流',
            title_en:'Multi-terminal Draw product',
            img:require("../assets/images/timg1.jpg")
          },
          {
            title:'视频编解码服务器',
            title_en:'Video Codec Server',
            img:require("../assets/images/timg2.jpg")
          },
          {
            title:'媒资管理平台',
            title_en:'Media Management product',
            img:require("../assets/images/timg3.jpg")
          },
          {
            title:'数据处理平台',
            title_en:'Data Processing product: Acquisition, Cleaning, Processing, Storage, Analysis, Labeling and Storage',
            img:require("../assets/images/timg4.jpg")
          },
          {
            title:'数据可视化平台',
            title_en:'Orchestration Data Visualization product (Atlas, Word Cloud, Yearbook, Internet of Things Data)',
            img:require("../assets/images/timg5.jpg")
          },
          {
            title:'云导播平台',
            title_en:'Cloud Guide product',
            img:require("../assets/images/timg6.jpg")
          },
        ],
        solution:{
          title:'多终端拉流',
          title_en:'Multi-terminal Draw product',
          img:require("../assets/images/timg.jpg")
        },
        // 解决方案-------------------

        // 产品-----------------------
        products:[
          {
            title:'控播平台',
            title_en:'Level Control Broadcasting Station',
            img:require("../assets/images/timg.jpg")
          },
          {
            title:'多媒体推送平台',
            title_en:'Multimedia Push Platform',
            img:require("../assets/images/timg1.jpg")
          },
          {
            title:'媒资管理平台',
            title_en:'Level Control Broadcasting Station',
            img:require("../assets/images/timg2.jpg")
          },
          {
            title:'双向视频APP',
            title_en:'Bidirectional Video APP',
            img:require("../assets/images/timg3.jpg")
          },
          {
            title:'手机直播APP',
            title_en:'Mobile Live APP',
            img:require("../assets/images/timg4.jpg")
          },
          {
            title:'视频点播',
            title_en:'video on demand',
            img:require("../assets/images/timg5.jpg")
          },
          {
            title:'视频直播',
            title_en:'Video Live Broadcasting',
            img:require("../assets/images/timg6.jpg")
          },
          {
            title:'云导播',
            title_en:'Cloud broadcasting',
            img:require("../assets/images/timg7.jpg")
          },
        ],
        productShow:true,
        // 产品-----------------------

        // 服务-----------------------
        services:[
          {
            title:'咨询',
            title_en:'Consultation',
            img:require("../assets/images/timg5.jpg")
          },
          {
            title:'设计',
            title_en:'Design',
            img:require("../assets/images/timg6.jpg")
          },
          {
            title:'执行',
            title_en:'implement',
            img:require("../assets/images/timg7.jpg")
          },
          {
            title:'支持',
            title_en:'Support',
            img:require("../assets/images/timg8.jpg")
          },
        ],
        // 服务-----------------------

        // 我们的案例----------------------
        ourCase:[
          {
            title:'CUTV蛇口港',
            title_en:'CUTV Shekou Port',
            img:require("../assets/images/timg1.jpg")
          },
          {
            title:'图书馆',
            title_en:'Library',
            img:require("../assets/images/timg2.jpg")
          },
          {
            title:'民政局',
            title_en:'Ming Political Bureau',
            img:require("../assets/images/timg3.jpg")
          },
          
          {
            title:'民政局',
            title_en:'Ming Political Bureau',
            img:require("../assets/images/timg4.jpg")
          },
        ],
        // 我们的案例----------------------

      }
    },
    methods:{
      linkto(url) {
        window.open(url)
      },
      // 置顶，点击logo
      toTop(){
        $('html , body').animate({scrollTop:0}, 1000);
      },
      // 导航栏菜单点击事件---------------------
      navigateTo(index){
        this.$router.push(index)
      },

      //解决方案------------------------------
      // 鼠标移入
      solutionItemMoveOver(idx){
        const that = this
        console.log("鼠标移入:",idx)
        let solutions = that.solutions
            solutions[idx].show=true
            that.solutions =solutions
        let solutionsRight = that.solutionsRight
        const item =solutionsRight[idx]
              that.solution =item
      },
      // 鼠标移出
      solutionItemMoveOut(idx){
        const that = this
        console.log("鼠标移出:",idx)
        let solutions = that.solutions
            solutions[idx].show=false
            that.solutions =solutions
      },
      
      solutionImgMoveOver(){
        console.log("solutionImgMoveOver")
        // $('.solution-right').slideDown("slow");
        $('.solution-right').animate({
          top:0,
        },500)
        $('.solution-right-img').animate({
          width:this.clientWidth/2+'px',
          height:this.clientHeight/2+'px',
        },500)
        
      },
      solutionImgMoveOut(){
        console.log("solutionImgMoveOut")
        // $('.solution-right-img').slideUp("slow");
        $('.solution-right').animate({
          top:-this.clientHeight*5/12+'px'
        },500)
        $('.solution-right-img').animate({
          width:this.clientWidth*5/12+'px',
          height:this.clientHeight*5/12+'px',
        },500)
      },
      //footer----------------------------------
      footerItemMoveOver(idx){
        const that = this
        $(".footer-item").eq(idx).children(".footer-item-title").css({"color":"#F06A39","text-decoration":"underline"})
        $(".footer-item").eq(idx).siblings().children(".footer-item-title").css({"color":"white","text-decoration":"none"})
      },
      footerItemMoveOut(idx){
        const that = this
        $(".footer-item").eq(idx).children(".footer-item-title").css({"color":"white","text-decoration":"none"})
      },
    
      //产品---------------------------------------
    },
    mounted:function(){
      const that = this
      let wW = document.documentElement.clientWidth;// 窗口宽度
      let hH = document.documentElement.clientHeight;// 窗口高度
      console.log('宽度:',wW)
      console.log('高度:',hH)
      that.clientHeight=hH
      that.clientWidth=wW
      
      window.onscroll = function(){
        var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
        if(scrollTop==0){
          that.transparent=true
        }else{
          that.transparent=false
        }
      }

      let productShow=true
      if(wW<768){
        if(wW>hH){
          that.footerHeight=wW/2
          productShow=true
        }else{
          that.footerHeight=hH/2
          productShow=false
        }
        that.show=false
      }else{
        that.footerHeight=hH/4
        that.show=true
        productShow=true
      }

      if(wW>hH){
        that.half=wW/2
      }else{
        that.half=hH/2
      }
      that.productShow=productShow
      console.log("adfsd:",productShow)
      //banners轮播图swiper
      var swiper = new Swiper('.swiper-container', {
        autoplay: true,
        speed: 1000,
        autoplayDisableOnInteraction: false,
        loop: true, // 循环模式选项
        slidesPerView: 1,//显示个数
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.next-img',
          prevEl: '.pre-img',
        },
      });

      // 产品
      if(productShow){
        var swiper2 = new Swiper('.products', {
          slidesPerView: 3,//显示个数
          spaceBetween: 10,
          navigation: {
            nextEl: '.product-next-img',
            prevEl: '.product-pre-img',
          },
        });
      }else{
        var swiper2 = new Swiper('.products', {
          slidesPerView: 1,
          spaceBetween: 10,
          navigation: {
            nextEl: '.product-next-img',
            prevEl: '.product-pre-img',
          },
        });
      }
    },
    created:function(){
      
    },
    destroyed:function(){}
  }
</script>

<style scoped>
@import url("../../static/css/global.css");
.click{
  cursor: pointer;
}
.navigate{
  position: fixed;
  top:0;
  z-index: 1000;
  width:100%;
}
.logo{
  width:100px;
  height:50px;
  top:0;
  position: fixed;
  z-index:2000;
}
.menu-img{
  width:30px;
  height:30px;
  border:1px solid white;
  border-radius: 3px;
}
.navigate-menu-item{
  height:50px;
  line-height: 50px;
}

/* 轮播图 */
.pre-next{
  width:100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  top:-50%;
  z-index:10;
}
.section-title{
  height:200px;
  display: flex;
  align-items: center;
  margin-left: 5%;
}
.section-line{
  width:50px;
  min-width: 50px;
  height:2px;
  background:chocolate;
}
.section-h3{
  margin-top:30px;
}

/* 解决方案 */
.solution-item{
  width:33.33%;
  min-width: 33.33%;
}

.solution-item-title{
  height:50px;
  min-height: 50px;
  max-height: 50px;
}

.soution-right-text{
  margin-left: 10%;
  margin-top:20%;
}
/* 产品 */
.products{
  position: relative;
  z-index: 20;
}
.product-pre-next{
  width:100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  top:-55%;
  z-index:10;
}

/* 服务 */
.service-text{
  margin-left: 20px;
  margin-top:20px;
  background-color:rgba(0,0,0,0.5);
  padding:20px;
}
.service-text2{
  background:rgba(0,0,0,0.5);
  padding:20px;
}

.toMore{
  border-radius: 3px;
  border:2px solid #F06A39;
  width:50px;
  margin-top:20px;  
  text-align: center;
  color:#F06A39;
}

/* 我们的案例 */

/* 底部内容 */
.footer{
  width:100%;
  background-image:url('../assets/images/footer_bg.png');
  background-size:100% 100%;
}
input{
	font-size: 30px;
	border:none;
	outline: none;
	/* background-color: transparent !important; */
}
input:focus{   
	border:none;
}
input::-webkit-input-placeholder{
	font-size: 30px;
	/* background-color: transparent !important; */
}
.footer-input{
  height:50px;
  width:90%;
  background:white;
  border-radius: 5px;
}
.footer-submit{
  height:50px;
  line-height:50px;
  font-size: 20px;
  color: white;
  text-align: center;
  background: #F06A39;
  border-radius: 5px;
}

.footer-line{
  width:100%;
  height:1px;
  min-height: 1px;
  background: white;
}
.footer-copyright{
  height: auto;
  max-height: 50px;
  line-height: 50px;
  word-wrap: break-word;
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/pages/Index.vue